import React, { Component } from "react";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import { Div, Text, Image, Row, Col } from "atomize";

export default class EngagementDashboard extends Component {
  render() {
    const { content } = this.props;
    return (
      <WebsiteContainer>
        <CustomContainer>
          <Div>
            <Div>
              <Text
                maxW="46rem"
                m={{ b: ".7rem" }}
                textSize="title2"
                textWeight="700"
                tag="h2"
              >
                {content.heading}
              </Text>
              <Text textSize="paragraph" m={{ b: "2.6rem" }}>
                {content.subHeading}
              </Text>
              <Row>
                {content.info.map((data, index) => {
                  return (
                    <Col size="6" key={index}>
                      <Div
                        d="flex"
                        m={{ b: "2rem" }}
                        p={{ l: index % 2 && "3.75rem" }}
                      >
                        <Div p={{ y: "7px" }}>
                          <Image
                            alt={data.alt && data.alt}
                            src={data.image}
                            h="2.31rem"
                            w="1.75rem"
                          />
                        </Div>
                        <Div m={{ l: "1.2rem" }}>
                          <Text textSize="paragraph" textWeight="bold" tag="h3">
                            {data.heading}
                          </Text>
                          <Text textColor="gray700">{data.info}</Text>
                        </Div>
                      </Div>
                    </Col>
                  );
                })}
              </Row>
            </Div>
            <Text textColor="#D9D9D9">{content.footerText}</Text>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}
